import axios from "../axiosConfig";

class Routes {
  getUser(id) {
    return axios.get(`/user/${id}`);
  }
  getQuoteColumnsPreferences(id) {
    return axios.get(`/user/quotes-columns/${id}`);
  }
  updateQuoteColumnsPreferences(id, data) {
    return axios.patch(`/user/quotes-columns/${id}`, data);
  }
  getAllUsers() {
    return axios.get(`/user`);
  }

  searchUsersByPhone(phone) {
    return axios.get(`/user/search-by-phone`, { params: { phone } });
  }
  updateUser(id, data) {
    return axios.patch(`/user/${id}`, data);
  }

  userPoints(id) {
    return axios.get(`/user/points/${id}`);
  }

  verifyXevoraAPI() {
    return axios.get(`/user/verify/xevora-api`);
  }

  createUserByAdmin(data) {
    return axios.post(`/user/admin-create`, data);
  }
}

export default new Routes();
